import { getNaaviCrud } from "./naaviClient";
import {
  AvailabilityPayload,
  GetTherapyOptionsPayload,
  AvailabilityResponse,
  AvailabilityCalendarResponse,
  AvailabilityCalendarBatchRequest,
  AvailabilityCalendarBatchResponse,
  AvailabilitySlotResponse,
  GeocodeForwardRequest,
  GeocodeReverseRequest,
  GeocodeResponse,
} from "./types";
import type { CustomerBookingsResponse } from "./types";
// import { prebookPayload } from './types';

const baseUrl = "/api/internal";
const crud = getNaaviCrud();

function buildQueryString(params?: Record<string, unknown>) {
  if (!params) {
    return "";
  }
  const entries = Object.entries(params);
  if (!entries.length) {
    return "";
  }
  const searchParams = new URLSearchParams();
  entries.forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    const normalized = String(value);
    if (!normalized.length) {
      return;
    }
    searchParams.append(key, normalized);
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export function availability(payload: AvailabilityPayload) {
  return crud.httpPost(`${baseUrl}/availability`, payload, undefined, "json", {
    headers: {
      Accept: "*/*",
    },
  }) as Promise<AvailabilityResponse>;
}

// Returns user + resource + tenant for a professional without touching availability.
// Lets the profile render even when the professional has no slots today.
export function professionalBase(tenantId: string, userId: number) {
  return crud.httpGet(
    `${baseUrl}/professional/${encodeURIComponent(tenantId)}/${userId}`,
    null,
    undefined,
    "json",
    { headers: { Accept: "*/*" } },
  ) as Promise<{
    tenantId: string;
    user: Record<string, unknown>;
    resource: Record<string, unknown> | null;
    tenant: Record<string, unknown>;
  }>;
}

export function availabilitySummary(payload: AvailabilityPayload) {
  const summaryPayload = {
    ...payload,
    includeSchedule: false,
    includeAllSchedules: false,
  };
  return availability(summaryPayload);
}

export function getAvailabilityCalendar(
  tenantKey: string,
  resourceId: number,
  bookingTypeId: number,
  params?: Record<string, unknown>,
) {
  const query = buildQueryString(params);
  return crud.httpGet(
    `${baseUrl}/availability/tenants/${tenantKey}/resources/${resourceId}/booking-types/${bookingTypeId}/calendar${query}`,
    null,
    undefined,
    "json",
    {
      headers: {
        Accept: "*/*",
      },
    },
  ) as Promise<AvailabilityCalendarResponse>;
}

// export function getAvailabilityCalendarBatch(
//   payload: AvailabilityCalendarBatchRequest,
// ) {
//   return crud.httpPost(
//     `${baseUrl}/availability/calendar/batch`,
//     payload,
//     undefined,
//     "json",
//     {
//       headers: {
//         Accept: "*/*",
//       },
//     },
//   ) as Promise<AvailabilityCalendarBatchResponse>;
// }

// export function getAvailabilitySlot(
//   tenantKey: string,
//   resourceId: number,
//   bookingTypeId: number,
//   params: Record<string, unknown> & { date: string; time: string },
// ) {
//   const query = buildQueryString(params);
//   return crud.httpGet(
//     `${baseUrl}/availability/tenants/${tenantKey}/resources/${resourceId}/booking-types/${bookingTypeId}/slots?${query}`,
//     null,
//     undefined,
//     "json",
//     {
//       headers: {
//         Accept: "*/*",
//       },
//     },
//   ) as Promise<AvailabilitySlotResponse>;
// }

export function getTherapyOptions(payload: GetTherapyOptionsPayload) {
  return crud.httpPost(
    `${baseUrl}/therapy-options`,
    payload,
    undefined,
    "json",
    {
      headers: {
        Accept: "*/*",
      },
    },
  );
}

export function customerBookings() {
  return crud.httpGet(`${baseUrl}/customer-bookings`, null, undefined, "json", {
    headers: {
      Accept: "*/*",
    },
  }) as Promise<CustomerBookingsResponse>;
}

export function geocodeForward(payload: GeocodeForwardRequest) {
  return crud.httpPost(
    `${baseUrl}/geocode/forward`,
    payload,
    undefined,
    "json",
    {
      headers: {
        Accept: "*/*",
      },
    },
  ) as Promise<GeocodeResponse>;
}

export function geocodeReverse(payload: GeocodeReverseRequest) {
  return crud.httpPost(
    `${baseUrl}/geocode/reverse`,
    payload,
    undefined,
    "json",
    {
      headers: {
        Accept: "*/*",
      },
    },
  ) as Promise<GeocodeResponse>;
}
